export default __webpack_public_path__ + "static/agile-solution-18c8a1118275c02d4a0344b6b965e0e9.png";